export default __webpack_public_path__ + "static/media/stripe_logo.5bb064ff.png";